module.exports = __webpack_public_path__ + "img/Picture1.c46b61dc.png";